import React, {Component} from 'react'
import LazyLoad from 'react-lazy-load';
import {withTranslation} from 'react-i18next';
import moment from 'moment'
require('moment/locale/de')

// Decorate the class.
@withTranslation()
export default class ResidentialMarketList extends Component {

	/**
	 * @param {object} props
	 */
	constructor(props) {
		super(props)
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t, callForApplicationItem} = this.props;

    let callForApplicationItemPictureUri = callForApplicationItem.pictures[0] ? callForApplicationItem.pictures[0].uri : '';

    let hasPictureVariants = false;
    let variant320SrcSetString = ''
    let variant550SrcSetString = ''

    if (callForApplicationItem.pictures.length > 0 && callForApplicationItem.pictures[0].variants.length > 0) {
      hasPictureVariants = true;
      for (let variant of callForApplicationItem.pictures[0].variants) {
        switch (variant.width) {
          case 2400:
            // this image size will be used for image lightbox
            continue;
          case 550:
            variant550SrcSetString = variant.uri + ' 550w';
            continue;
          case 320:
            callForApplicationItemPictureUri = variant.uri;
            variant320SrcSetString = variant.uri + ' 320w';
        }
      }
    }

    const callForApplicationItemPictureSrcSet = variant320SrcSetString + ', ' + variant550SrcSetString;
    const match = callForApplicationItemPictureUri.match(/\.(\w+)(\?.*)?$/);
    const fileNameSuffix = match ? match[1] : null;;
    const fileTypeClass = fileNameSuffix ? `type-${fileNameSuffix}` : '';

		/*
		 data-residentialarea={callForApplicationItem.realEstateObject.residentialArea}
		 data-locality={callForApplicationItem.realEstateObject.locality}
		 data-rooms={callForApplicationItem.realEstateObject.rooms}
		 */
		return (
			<div className="callForApplication__item">
				{this.props.itemIndex === 0 && callForApplicationItem.availableFrom &&
				<h3 className="callForApplicationItem__groupHeader">
					per {moment(callForApplicationItem.availableFrom).format('D. MMMM YYYY')}</h3>}
				<div className={`row callForApplicationItem__inner ${callForApplicationItem.unavailable && 'callForApplicationItem__unavailable'}`}>
					<div className="col-12 col-md-5 image__container">
            {callForApplicationItem.pictures.length > 0 ?
              <img className={`residential-market-img ${fileTypeClass}`}
                   src={callForApplicationItemPictureUri}
                   srcSet={hasPictureVariants ? callForApplicationItemPictureSrcSet : ""}
                   sizes={hasPictureVariants ? "(max-width: 769px) 550px, (min-width: 770px) 320px" : ""}
                   alt={callForApplicationItem.title} /> :
              <LazyLoad>
                <img className="residential-market-img"
                     src={`/webapi/residential-area-image/${callForApplicationItem.realEstateObject.residentialArea}`}/>
              </LazyLoad>
            }
					</div>
					<div className="col-12 col-md-7 callForApplicationItem__info">
						<h5>{callForApplicationItem.title}</h5>
						<p>
							{callForApplicationItem.realEstateObject.floor}
							{callForApplicationItem.realEstateObject.position && ` ${callForApplicationItem.realEstateObject.position}`},
							Netto-Wohnfläche
							ca. {callForApplicationItem.livingSpace} m²{callForApplicationItem.addressComment && `, ${callForApplicationItem.addressComment}`}<br />
							{callForApplicationItem.netRent && `Monatlicher Mietzins CHF ${callForApplicationItem.netRent}`}
							&nbsp;
							{callForApplicationItem.extraRent && `plus CHF ${callForApplicationItem.extraRent} NK`}
							{callForApplicationItem.rentComment &&
							<span>, {callForApplicationItem.rentComment}</span>}
							{callForApplicationItem.comment &&
              				<span style={{'whiteSpace': 'pre-line','wordWrap': 'break-word','overflowWrap': 'break-word'}}><br />{callForApplicationItem.comment}</span>}
							{callForApplicationItem.fixedTermLeaseEndDateTime &&
							<span><br />Befristeter Mietvertrag bis {moment(callForApplicationItem.fixedTermLeaseEndDateTime).format('D.M.YYYY')}</span>}
						</p>
						<p>
                            {callForApplicationItem.documents && callForApplicationItem.documents.map((document, index) => {
                                return (
									<span key={index}><a target="_blank"
											 href={document.uri}>{document.title ? document.title : document.fileName}</a><br /></span>
                                )
                            })}
							<a href={`/webapi/residential-area/${callForApplicationItem.realEstateObject.residentialArea}`}>
								Zur Siedlung
							</a>
						</p>
						<div className="item__position d-md-none">
							{callForApplicationItem.position}
						</div>
					</div>
					<div className="item__position d-none d-md-block">
						{callForApplicationItem.position}
					</div>
					<div className="button__container">
						{this.props.isInBasket(callForApplicationItem)
							?
							<button onClick={this.props.removeFromBasket.bind(this, callForApplicationItem)}
							        className="btn btn-secondary btn-sm">
								{t('residentialMarket.removeFromBasket')}
							</button>
							:
							<button onClick={this.props.addToBasket.bind(this, callForApplicationItem)}
							        title={this.props.isBasketFull() ? 'Sie haben bereits 5 Wohnungen ausgewählt.' + this.props.isBasketFull() : callForApplicationItem.unavailable ? 'Diese Wohnung ist bereits vermietet.' : ''}
							        disabled={callForApplicationItem.unavailable || this.props.isBasketFull() || this.props.applicationIsRunning === false}
							        className={`btn btn-sm ${!callForApplicationItem.unavailable && 'btn-primary'}`}>
								{callForApplicationItem.unavailable
									? t('residentialMarket.rented')
									: t('residentialMarket.addToBasket')
								}
							</button>
						}
					</div>

				</div>
			</div>
		)
	}
}
